// extracted by mini-css-extract-plugin
export var container = "PhoneCarousel-module--container--224cb";
export var navButton = "PhoneCarousel-module--navButton--bbe99";
export var navButtonCircle = "PhoneCarousel-module--navButtonCircle--2eccd";
export var navButtonIcon = "PhoneCarousel-module--navButtonIcon--f753a";
export var phone = "PhoneCarousel-module--phone--bbb50";
export var wrapper = "PhoneCarousel-module--wrapper--bff27";